<template>
  <div v-if="visible" class="fixed inset-0 z-[130] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="$emit('close')">
    <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl max-w-md w-full border border-slate-200 dark:border-slate-800">
      <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex justify-between items-center">
        <h3 class="text-lg font-bold text-slate-900 dark:text-white">Client Settings</h3>
        <button @click="$emit('close')" class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1 rounded-md hover:bg-slate-200 dark:hover:bg-slate-800">
          <RadIcon name="X" :size="20" />
        </button>
      </div>
      
      <div class="p-6 space-y-6">
        <!-- Max Loaded Channels -->
        <div>
          <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
            Max Loaded Channels
          </label>
          <p class="text-xs text-slate-500 dark:text-slate-400 mb-3">
            Number of channels to keep loaded in memory. Lower values use less memory but switching channels may be slower.
          </p>
          <div class="flex items-center gap-4">
            <div class="flex-1">
              <input
                type="range"
                v-model.number="localSettings.maxLoadedChannels"
                min="1"
                max="5"
                step="1"
                class="w-full h-2 bg-slate-200 dark:bg-slate-700 rounded-lg appearance-none cursor-pointer accent-blue-600"
              />
              <div class="flex justify-between text-xs text-slate-400 dark:text-slate-500 mt-1">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
              </div>
            </div>
            <span class="text-sm font-mono font-bold text-slate-900 dark:text-white w-8 text-center">
              {{ localSettings.maxLoadedChannels }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="px-6 py-4 border-t border-slate-200 dark:border-slate-800 flex justify-end gap-3">
        <RadButton @click="$emit('close')" variant="ghost">Cancel</RadButton>
        <RadButton @click="saveSettings" variant="primary">Save</RadButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useClientSettings } from '@/composables/useClientSettings'

const props = defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const { settings, updateSettings } = useClientSettings()

const localSettings = ref({ ...settings.value })

watch(() => props.visible, (isVisible) => {
  if (isVisible) {
    localSettings.value = { ...settings.value }
  }
})

function saveSettings() {
  updateSettings({ maxLoadedChannels: localSettings.value.maxLoadedChannels })
  emit('close')
}
</script>
